import { IconProps } from './types';

export function Stop({ size, ...props }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" viewBox="0 0 25 25" {...props}>
      <rect x="5" y="5" width="16" height="16" rx="2" ry="2" fill="currentColor" />
    </svg>
  );
}
